import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';

export const useNotifyOnDeletion = (isSuccess: boolean) => {
  useEffect(() => {
    if (isSuccess) {
      enqueueSnackbar('Service deleted', { variant: 'success' });
    }
  }, [isSuccess]);
};
